﻿export interface IRccapAdditionalQuestion {
    id: number;
    rccapId: number;
    question: string;
    answer: string;
    answeredBy: number;
    answeredDateTime: string;
}
